import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    name: "",
    email: "",
    _id: "",
  },
  products: [],
  /**
   * Properties for the global color
   * color: color of the global color
   * contrast: contrast of the global color
   * text: text of the global color
   * square: square of the global color
   */
  color: undefined,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },

    removeUser: (state) => {
      state.user = initialState.user;
    },

    // products

    saveProducts: (state, action) => {
      state.products = action.payload;
    },

    //color

    setColor: (state, action) => {
      state.color = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, removeUser, saveProducts, setColor } =
  userSlice.actions;

export default userSlice.reducer;
